var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('BTable',{ref:"table",staticStyle:{"margin-top":"20px"},attrs:{"size":"default","rowKey":function (text, index) { return index; },"scroll":{ x: true },"columns":_vm.columns,"data":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }